import Vue from 'vue';
import store from '@/store';
import Router from 'vue-router';
Vue.use(Router);
// 解决路由重复点击报异常问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject)
		return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
	if (onResolve || onReject)
		return originalReplace.call(this, location, onResolve, onReject);
	return originalReplace.call(this, location).catch((err) => err);
};

const Login = () =>
	import( /* webpackChunkName: "login" */ '../views/home/Login.vue'); // 登录页面
const Home = () => import( /* webpackChunkName: "home" */ '../views/home/Home.vue'); // 主界面

const orderList = () =>
  import(/* DanniaoOrder: "orderList" */ '../views/order/orderList.vue'); // 分公司列表
const routes =[
 {
		path: '/',
		name: 'Login',
		component: Login,
		meta: {
			noNeedAuth: true,
			keepAlive: false, // 不需要缓存
		},
	},
	{
		path: '/home',
		name: '',
		component: Home,
		meta: {
			keepAlive: false, // 不需要缓存
		},
		children: [{
				path: "/",
				name: "WELCOME",
				component: () => import( /* webpackChunkName: "operationLog" */ "../views/home/welcome.vue"),
				meta: {
					title: "欢迎页",
					noNeedAuth: true
				}
			},
			{
				path: "changePassword",
				name: "changePassword",
				component: () => import( /* webpackChunkName: "changePassword" */
					"../views/home/changePassword.vue"),
				meta: {
					title: "修改密码",
					noNeedAuth: true
				}
			},
			{
				path: 'userList',
				name: 'USERLIST',
				component: () => import( /* webpackChunkName: "userList" */ "../views/system/userList.vue"),
				meta: {
					keepAlive: true,
				},
			},
			{
				path: 'roleList',
				name: 'ROLELIST',
				component: () => import( /* webpackChunkName: "roleList" */ "../views/system/roleList.vue"),
				meta: {
					keepAlive: true,
				},
			},
			{
				path: 'operationLog',
				name: 'OPERATIONLOG',
				component: () => import( /* webpackChunkName: "operationLog" */
					"../views/system/operationLog.vue"),
				meta: {
					keepAlive: true,
				},
			},

		],
	},
	// 01:用户管理
	{
		path: '/vip',
		name: 'SETTING',
		component: Home,
		meta: {
			keepAlive: false, // 不需要缓存
		},
		children: [{
			path: 'vipList',
			name: 'VIPLIST',
			component: () => import("../views/vip/vipList.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'vipDetail/:id', // 带id参数
			name: 'VIPDETAIL',
			component: () => import("../views/vip/vipDetail.vue"),
			meta: {
				keepAlive: false,
				parentName: 'VIPLIST'
			},
		}],
	},
	// 02:工厂管理
	{
		path: '/factory',
		name: 'SETTING',
		component: Home,
		meta: {
			keepAlive: false, // 不需要缓存
		},
		children: [{
			path: 'factoryManage',
			name: 'FACTORYMANAGE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/factory/factoryManage.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'factoryDetail/:type/:ifFacOrBr/:id?', // 带id参数
			name: 'FACTORYDETAIL',
			component: () => import("../views/factory/factoryDetail.vue"),
			meta: {
				keepAlive: false, // 编辑页每次重新创建，避免缓存导致脏状态残留
			},
		}],
	},
	// 03:品牌管理
	{
		path: '/brand',
		name: 'SETTING',
		component: Home,
		meta: {
			keepAlive: false, // 不需要缓存
		},
		children: [{
			path: 'brandpage',
			name: 'BRANDMANAGE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/brand/brandpage.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'brandDetail/:type/:ifFacOrBr/:id?', // 带id参数
			name: 'BRANDDETAIL',
			component: () => import("../views/brand/brandDetail.vue"),
			meta: {
				keepAlive: false, // 详情页一般不需要缓存
			},
		}],
	},
	// 04:法规管理
	// 法规管理20260521 start
	{
		path: '/regulation',
		name: 'REGULATION',
		component: Home,
		meta: {
			keepAlive: true, // 不需要缓存
		},
		children: [{
			path: 'executionStandard',
			name: 'EXECUTIONSTANDARD',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/regulation/executionStandard.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'lawsRegulations',
			name: 'LAWSREGULATIONS',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/regulation/lawsRegulations.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'triggerCase',
			name: 'TRIGGERCASE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/regulation/triggerCase.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'complaintGuide',
			name: 'COMPLAINTGUIDE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/regulation/complaintGuide.vue"),
			meta: {
				keepAlive: true,
			},
		}],
	},
	// 法规管理20260521 end
	// 05:标签管理
	// 标签管理20260521 start
	{
		path: '/label',
		name: 'LABEL',
		component: Home,
		meta: {
			keepAlive: true, // 不需要缓存
		},
		children: [{
			path: 'labelSettings',
			name: 'LABELSETTINGS',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/label/labelSettings.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'fctory_band_spplierManage',
			name: 'FCTORY_BAND_SPPLIERMANAGE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/label/fctory_band_spplierManage.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'homepage',
			name: 'HOMEPAGE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/label/homepage.vue"),
			meta: {
				keepAlive: true,
			},
		}],
	},
	// 标签管理20260521 end
	// 06:互动管理
	// 互动管理20260521 start
	{
		path: '/inter',
		name: 'INTER',
		component: Home,
		meta: {
			keepAlive: true, // 不需要缓存
		},
		children: [{
			path: 'wordmouthPage',
			name: 'WORDMOUTHPAGE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/inter/wordmouthPage.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'complaintManage',
			name: 'COMPLAINTMANAGE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/inter/complaintManage.vue"),
			meta: {
				keepAlive: true,
			},
		},  {
			path: 'complaintManageDetail/:id',
			name: 'COMPLAINTDETAILMANAGE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/inter/complaintManageDetail.vue"),
			meta: {
				keepAlive: true,
			},
		},{
			path: 'sensitiveWordManage',
			name: 'SENSITIVEWORDMANAGE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/inter/sensitiveWordManage.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'roleManage',
			name: 'ROLEMANAGE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/inter/roleManage.vue"),
			meta: {
				keepAlive: true,
			},
		}],
	},
	// 07:广告管理
	{
		path: '/ad',
		name: 'AD',
		component: Home,
		meta: {
			keepAlive: false, // 不需要缓存
		},
		children: [{
			path: 'adManage',
			name: 'ADMANAGE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/ad/adManage.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'adDetail/:id', // 带id参数
			name: 'ADDETAIL',
			component: () => import("../views/ad/adDetail.vue"),
			meta: {
				keepAlive: false, // 详情页一般不需要缓存
			},
		}],
	},
	// 08:搜索管理
	{
		path: '/search',
		name: 'SEARCH',
		component: Home,
		meta: {
			keepAlive: false, // 不需要缓存
		},
		children: [{
			path: 'searchManage',
			name: 'SEARCHMANAGE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/search/searchManage.vue"),
			meta: {
				keepAlive: true,
			},
		}],
	},
	// 互动管理20260521 end
	// 09:客服管理
	{
		path: '/custService',
		name: 'CUSTSERVICE',
		component: Home,
		meta: {
			keepAlive: false, // 不需要缓存
		},
		children: [{
			path: 'oemConsult',
			name: 'OEMCONSULT',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/custService/oemConsult.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'oemConsultDetail/:id', // 带id参数
			name: 'OEMCONSULTDETAIL',
			component: () => import("../views/custService/oemConsultDetail.vue"),
			meta: {
				keepAlive: false, // 详情页一般不需要缓存
			},
		} ,{
			path: 'feedBack',
			name: 'FEEDBACK',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/custService/feedBack.vue"),
			meta: {
				keepAlive: true,
			},
		},{
			path: 'feedBackDetail/:id', // 带id参数
			name: 'FEEDBACKDETAIL',
			component: () => import("../views/custService/feedBackDetail.vue"),
			meta: {
				keepAlive: false, // 详情页一般不需要缓存
			},
		}, {
			path: 'msgChannelMng',
			name: 'MSGCHANNELMNG',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/custService/msgChannelMng.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'serviceScriptMng',
			name: 'SERVICESCRIPTMNG',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/custService/serviceScriptMng.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'hotlineQrcode',
			name: 'HOTLINEQRCODE',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/custService/hotlineQrcode.vue"),
			meta: {
				keepAlive: true,
			},
		}, {
			path: 'sysMsg',
			name: 'SYSMSG',
			component: () => import( /* webpackChunkName: "quotationList" */
				"../views/custService/sysMsg.vue"),
			meta: {
				keepAlive: true,
			},
		}],
	},

	// 010:系统管理  todo
	{
		path: '/setting',
		name: 'SETTING',
		component: Home,
		meta: {
			keepAlive: false, // 不需要缓存
		},
		children: [{
				path: 'settingGeneral',
				name: 'SETTINGGENERAL',
				component: () => import( /* webpackChunkName: "quotationList" */
					"../views/setting/settingGeneral.vue"),
				meta: {
					keepAlive: true,
				},
			}, {
				path: 'settingCountryList',
				name: 'SETTINGCOUNTRYLIST',
				component: () => import( /* webpackChunkName: "quotationList" */
					"../views/setting/settingCountryList.vue"),
				meta: {
					keepAlive: true,
				},
			}, {
				path: 'settingBankList',
				name: 'SETTINGBANKLIST',
				component: () => import( /* webpackChunkName: "quotationList" */
					"../views/setting/settingBankList.vue"),
				meta: {
					keepAlive: true,
				},
			},
			{
				path: 'settingContentList',
				name: 'SETTINGCONTENTLIST',
				component: () => import( /* webpackChunkName: "quotationList" */
					"../views/setting/settingContentList.vue"),
				meta: {
					keepAlive: true,
				},
			},
			{
				path: 'settingVersionList',
				name: 'SETTINGVERSIONLIST',
				component: () => import( /* webpackChunkName: "quotationList" */
					"../views/setting/settingVersionList.vue"),
				meta: {
					keepAlive: true,
				},
			}
		],
	},
	// {
	// 	path: '/funds',
	// 	name: 'SETTING',
	// 	component: Home,
	// 	meta: {
	// 		keepAlive: false, // 不需要缓存
	// 	},
	// 	children: [{
	// 		path: 'walletList',
	// 		name: 'WALLETLIST',
	// 		component: () => import( /* webpackChunkName: "quotationList" */
	// 			"../views/funds/walletList.vue"),
	// 		meta: {
	// 			keepAlive: true,
	// 		},
	// 	}, {
	// 		path: 'withdrawalList',
	// 		name: 'WITHDRAWALLIST',
	// 		component: () => import( /* webpackChunkName: "quotationList" */
	// 			"../views/funds/withdrawalList.vue"),
	// 		meta: {
	// 			keepAlive: true,
	// 		},
	// 	}],
	// },
	//
	// {
	// 	path: '/notice',
	// 	name: 'SETTING',
	// 	component: Home,
	// 	meta: {
	// 		keepAlive: false, // 不需要缓存
	// 	},
	// 	children: [{
	// 		path: 'noticeList',
	// 		name: 'NOTICELIST',
	// 		component: () => import( /* webpackChunkName: "quotationList" */
	// 			"../views/notice/noticeList.vue"),
	// 		meta: {
	// 			keepAlive: true,
	// 		},
	// 	}],
	// },

]
const router = new Router({
	routes
});


// // 全局路由守卫
router.beforeEach(async (to, from, next) => {
  // 1. 白名单页面（如登录页、404页）直接放行
  if (to.meta.noNeedAuth) {
    console.log('000')
    return next();
  }
  if(store.state.userInfo==null){
    next('/')
    return
  }
// console.log(store.state.userInfo,'3333333333333333================================================================')
  // 2. 确保已获取权限数据（未获取则先请求）
  // if (store.state.accessibleRoutes.length === 0) {
  //   await store.dispatch('fetchPermissions');
  // }

  // 3. 校验目标路由是否在可访问列表中

  // orderList
  // console.log(to,to.name,'to.name',store.state.userInfo.resources)
	next();
  // const hasPermission = store.state.userInfo.resources.includes(to.name);
  // if (hasPermission) {
  //   next(); // 有权限，放行
  // } else {
  //   // next('/home'); // 无权限，跳转到首页
  // }

});

export default router;
